import BulletinBoardItemModal from './bulletin-board-item-modal-container'
export default BulletinBoardItemModal
